/* (c) Copyright Frontify Ltd., all rights reserved. */

export const STRIKETHROUGH_PLUGIN = 'strikethrough-plugin';
